import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';

import {getAllReports, getReportExcelFile, getAllActivities, getAllMaterials} from '../actions/reports';
import { addNotification as notify } from 'reapop';

import {toQuery} from '../utils/requests';
import * as actions from "../actions/checkIn";

export function fetchReports(data) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/report/dataTableGetWos`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          dispatch(getAllReports({ list: json }));
        }
      });
  }
}

export function fetchReportExcelFile(data) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/report`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          if (json && json.code == '410') {
            dispatch(getReportExcelFile({ excel: null }));
          } else {
            dispatch(getReportExcelFile({ excel: json }));
          }
        }
      })
      .catch(response => {
        dispatch(notify({
          title: 'Create Excel Report',
          message: 'Unable to create report file',
          status: 'warning',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }));
      });
  }
}


export function fetchMaterials(data) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/timeTracking/materials?${toQuery(data)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${userAuth.api_token}`
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          dispatch(getAllMaterials({ materials: json, loadedNewData: true }));
        }
      });
  }
}


export function fetchActivities(data) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/timeTracking/activities?${toQuery(data)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          dispatch(getAllActivities({ activities: json, loadedNewData: true }));
        }
      });
  }
}

export function fetchCheckIns(data) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/timeTracking/checkins?${toQuery(data)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {
          dispatch(getAllActivities({ activities: json, loadedNewData: true }));
        }
      });
  }
}

export function getWorkTimeCloseoutPdfFile(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/timeTracking/getWorkTimeCloseoutPdfFile?${toQuery(data)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          if (response.status !== 200) {
            return response.json().then(errorData => {
              throw errorData;
            });
          }
          return response.blob();
        })
        .then((blob) => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([blob], {type: "application/pdf"})

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          window.open(data);

          setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            //window.URL.revokeObjectURL(data);
          }, 100);

        })
        .catch(errorData => {
          if (errorData.hasOwnProperty('title') && errorData.hasOwnProperty('detail')) {
            dispatch(notify({
              title: errorData.title,
              message: errorData.detail,
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            return;
          }

          dispatch(notify({
            title: 'Report Download',
            message: 'Failed to download Report',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));

        });
      }
    }
};

export function downloadReportExcel(type, filename) {
  return (dispatch) => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/timeTracking/${type}/export`, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/plain',
        'Authorization': `bearer ${userAuth.api_token}`
      },
      credentials: 'same-origin',
      responseType: 'blob',
    })
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        let a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      })
      .catch(error => {
        dispatch(notify({
          title: 'Report Download',
          message: 'Failed to download Report',
          status: 'error',
          position: 'tr',
          dismissible: true,
          dismissAfter: 3000
        }));
      });
  }
};



// WEBPACK FOOTER //
// ./src/api/reports.js